import { CommercialMode, type CommercialModeTarget } from '@etiquetachef/types';

/**
 * Destinos possíveis de troca de tipo comercial a partir do tipo atual
 * (matriz 9.18 da #679): PARTNER → DIRECT ou COURTESY; DIRECT/COURTESY →
 * PARTNER. DIRECT↔COURTESY não entra porque tem botões próprios
 * ("Conceder/Remover cortesia"); DEMO e desconhecido → nenhum.
 *
 * Origem: #743 — 2026-09-25 17:32 +0200 (ativação pelo parceiro, matriz 9.18).
 *
 * Contrato: puro. `from` é `string` (vem de `effectiveCommercialMode`, que
 * pode devolver valor legado); compara pelas constantes `CommercialMode`
 * (#761), nunca pelo texto.
 *
 * Usado por: `BillingActions` (mostra o botão só se houver destino) e
 * `ChangeCommercialModeDialog` (opções do seletor), admin web. O servidor
 * (`changeTenantCommercialMode`) revalida a célula — esta lista é só UI.
 */
export function targetsFor(from: string): CommercialModeTarget[] {
  if (from === CommercialMode.PARTNER) return [CommercialMode.DIRECT, CommercialMode.COURTESY];
  if (from === CommercialMode.DIRECT || from === CommercialMode.COURTESY) return [CommercialMode.PARTNER];
  return [];
}
